import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { FaSave, FaSpinner, FaTimes } from 'react-icons/fa';
import { CloseIcon, ColoredColorIcon, SettingsModelIcon } from 'ui-component/custom-icons/icons'
import toast from 'react-hot-toast';

import { Skeleton } from '@mui/material';
import useIsMobile from 'utils/isMobileUtils';
import Select from 'react-select';
import ReactSelectCreatable from 'react-select/creatable';

// ✅ Clear
const ModelModal = ({ openPopup, details, handleClose, handleReloadList }) => {

    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [isFormProcessing, setIsFormProcessing] = useState(false);
    const [productCategories, setProductCategories] = useState(null);
    const [productColors, setProductColors] = useState(null);
    const [productStorages, setProductStorages] = useState(null);

    const [information, setInformation] = useState({
        id: '',
        productCategoryId: '',
        name: '',
        colors: [],
        storages: []
    });

    const handleProcessSubmit = () => {
        setIsFormProcessing(true);
        // handleSubmit(information);
        if (information?.productCategoryId == null || information?.productCategoryId == '') {
            toast.error('Category is required');
            setIsFormProcessing(false);
            return false;
        } else if (information?.name == null || information?.name == '') {
            toast.error('Model name is required');
            setIsFormProcessing(false);
            return false;
        }
        let request = {
            product_category_id: information?.productCategoryId,
            name: information?.name,
            colors: information?.colors,
            storages: information?.storages
        }

        if (information?.id == null || information?.id == '') {
            toast.promise(
                api
                    .settingsCreateModel(request)
                    .then((res) => {
                    if (res.status) {
                        handleReloadList()
                    }
                    setIsFormProcessing(false);
                    handleClose();

                    return res?.status == true ? res : null;
                }),

                {
                    loading: 'Creating model...',
                    success: (data) => `${data.message}`,
                    error: <b>Creating model Failed</b>
                }
            );
        } else {
            toast.promise(
                api
                    .settingsUpdateModel(details?.id, request)
                    .then((res) => {
                    if (res.status) {
                        handleReloadList()
                    }
                    setIsFormProcessing(false);
                    handleClose();

                    return res?.status == true ? res : null;
                }),

                {
                    loading: 'Updating model...',
                    success: (data) => `${data.message}`,
                    error: <b>Updating model Failed</b>
                }
            );
        }
    }

    const handleProcessEnter = (event) => {
        if (event.key === 'Enter') {
            handleProcessSubmit();
        }
    }

    const getData = () => {
        setIsDataLoaded(false);
        api
            .getSettingsModelDetails(details?.id)
            .then((res) => {
                setIsDataLoaded(true);
                if (res.status) {

                    const tempColors = res?.data?.data?.colors?.map((color) => ({
                        name: color?.name,
                        value: color?.color_id
                    }))
                    const tempStorages = res?.data?.data?.storages?.map((storage) => ({
                        name: storage?.name,
                        value: storage?.storage_id
                    }))

                    setInformation({
                        ...information,
                        id: details?.id,
                        name: res?.data?.data?.name,
                        productCategoryId: res?.data?.data?.category?.id,
                        colors: tempColors,
                        storages: tempStorages
                    })
                } else {
                    setInformation({
                        id: details?.id,
                        name: '',
                        productCategoryId: '',
                        colors: [],
                        storages: []
                    })
                }
            })
            .catch((error) => {
                setIsDataLoaded(true);
                setInformation(null);
            });
    };
    const getProductCategories = async () => {
        
        api.getSelectOptionsList('product_category').then((res) => {
            const tempList = res.data.map((item) => ({
                ...item,
                label: item.name,
                value: item.id,
            }));
            setProductCategories(tempList);
        });
    }
    const getProductColors = async () => {
        
        api.getSelectOptionsList('color').then((res) => {
            const tempList = res.data.map((item) => ({
                ...item,
                label: item.name,
                value: item.id,
            }));
            setProductColors(tempList);
        });
    }
    const getProductStorages = async () => {
        
        api.getSelectOptionsList('product_storage').then((res) => {
            const tempList = res?.data?.map((item) => ({
                ...item,
                label: item.name,
                value: item.id,
            }));
            setProductStorages(tempList);
            // setIsProductsLoaded(true)
        });
    }

    useEffect(() => {
        getProductCategories();
        getProductColors();
        getProductStorages();
        if (details?.id) {
            getData();
        } else {
            setIsDataLoaded(true);
            setInformation({
                id: '',
                productCategoryId: '',
                name: '',
                colors: [],
                storages: []
            })
        }
    }, [details])

    const isMobile = useIsMobile();
    
   if (!isMobile) return (
        <Modal show={openPopup}  centered size="md">
            <Modal.Body>
                <div className="p-2">
                    <div style={{ padding: '20px 0' }}>
                        <div className="mb-2 ml-0 pl-0">

                            <div className="row">
                                <div className="col-12 text-center">
                                    <SettingsModelIcon height={'60px'} width={'60px'} />
                                </div>
                            </div>
                            <button className="btn modal-close-icon" onClick={handleClose}>
                                <CloseIcon height={'16px'} width={'16px'} />
                            </button>
                        </div>

                        <div className="row align-items-top">
                            <div className="col-12 text-center " style={{ padding: '10px 0 20px 0' }}>
                                <div style={{ fontSize: '24px' }}>
                                    Model Details
                                </div>
                                <div className='textGray'>
                                    This model will be shown to the selection of models
                                </div>
                            </div>
                        </div>
                        <div className="row align-items-top" style={{ padding: '3px 0' }}>
                                    <div className="col-12 form-group">     
                                        <label>Category</label>
                                        {
                                            isDataLoaded == false ? (
                                                <div style={{ width: '100%' }}>
                                                    <Skeleton variant="rounded" width={'100%'} height={35} style={{ borderRadius: '12px' }} />
                                                </div>
                                            ) : (
                                                <Select
                                                    className="rs-container-est-white"
                                                    classNamePrefix="rs"
                                                    isSearchable={true}
                                                    name="customer"
                                                    options={productCategories}
                                                    value={productCategories?.find((option) => option.value === information?.productCategoryId) || null}
                                                    onChange={(e) => {
                                                    setInformation({
                                                        ...information,
                                                        productCategoryId: e?.value
                                                        });
                                                    }}
                                                />
                                            )
                                        }
                                    </div> 
                                    <div className="col-12 form-group">     
                                        <label>Model Name</label>
                                        {
                                            isDataLoaded == false ? (
                                                <div style={{ width: '100%' }}>
                                                    <Skeleton variant="rounded" width={'100%'} height={35} style={{ borderRadius: '12px' }} />
                                                </div>
                                            ) : (
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="inputName"
                                                    value={information?.name}
                                                    placeholder='Color name'
                                                    onChange={(e) => {
                                                        setInformation({
                                                            ...information,
                                                            name: e.target.value
                                                        })
                                                    }}
                                                    onKeyDown={(e) => {
                                                        handleProcessEnter(e);
                                                    }}
                                                />
                                            )
                                        }
                                    </div> 
                                    <div className="col-12 form-group">     
                                        <label>Colors</label>
                                        {
                                            isDataLoaded == false ? (
                                                <div style={{ width: '100%' }}>
                                                    <Skeleton variant="rounded" width={'100%'} height={35} style={{ borderRadius: '12px' }} />
                                                </div>
                                            ) : (
                                                <ReactSelectCreatable
                                                    className="rs-container"
                                                    classNamePrefix="rs"
                                                    options={productColors}
                                                    onChange={(e) => {
                                                        setInformation({
                                                            ...information,
                                                            colors: e
                                                        });
                                                    }}
                                                    isMulti={true}
                                                    value={information?.colors?.map((detail) => {
                                                        // If detail is an object with label and value, use it directly
                                                        if (detail?.label && detail?.value) {
                                                            // Check if value exists in productColors
                                                            const isExisting = productColors?.some((option) => option.value === detail.value);
                                                            return { ...detail, isNew: !isExisting };
                                                        }
                                                        // If detail is an object with name and value, map to label/value
                                                        if (detail?.name && detail?.value) {
                                                            const isExisting = productColors?.some((option) => option.value === detail.value);
                                                            return { label: detail.name, value: detail.value, isNew: !isExisting };
                                                        }
                                                        // If detail is a string (custom entry), map to label/value and mark as new
                                                        if (typeof detail === 'string') {
                                                            const isExisting = productColors?.some((option) => option.value === detail);
                                                            return { label: detail, value: detail, isNew: !isExisting };
                                                        }
                                                        // Fallback: try to find in options
                                                        const existingOption = productColors?.find((option) => option?.value === detail?.value);
                                                        if (existingOption) {
                                                            return { ...existingOption, isNew: false };
                                                        }
                                                        return { label: detail?.name || '', value: detail?.value || '', isNew: true };
                                                    })}
                                                    menuPlacement="auto"
                                                    menuPosition="fixed"
                                                    placeholder="Select or type..."
                                                />
                                            )
                                        }
                                    </div> 
                                    <div className="col-12 form-group">     
                                        <label>Storage</label>
                                        {
                                            isDataLoaded == false ? (
                                                <div style={{ width: '100%' }}>
                                                    <Skeleton variant="rounded" width={'100%'} height={35} style={{ borderRadius: '12px' }} />
                                                </div>
                                            ) : (
                                                <ReactSelectCreatable
                                                    className="rs-container"
                                                    classNamePrefix="rs"
                                                    options={productStorages}
                                                    onChange={(e) => {
                                                                setInformation({
                                                                    ...information,
                                                                    storages: e
                                                                });
                                                            }}
                                                    isMulti={true}
                                                    value={information?.storages?.map((detail) => {
                                                        // If detail is an object with label and value, use it directly
                                                        if (detail?.label && detail?.value) {
                                                            // Check if value exists in productStorages
                                                            const isExisting = productStorages?.some((option) => option.value === detail.value);
                                                            return { ...detail, isNew: !isExisting };
                                                        }
                                                        // If detail is an object with name and value, map to label/value
                                                        if (detail?.name && detail?.value) {
                                                            const isExisting = productStorages?.some((option) => option.value === detail.value);
                                                            return { label: detail.name, value: detail.value, isNew: !isExisting };
                                                        }
                                                        // If detail is a string (custom entry), map to label/value and mark as new
                                                        if (typeof detail === 'string') {
                                                            const isExisting = productStorages?.some((option) => option.value === detail);
                                                            return { label: detail, value: detail, isNew: !isExisting };
                                                        }
                                                        // Fallback: try to find in options
                                                        const existingOption = productStorages?.find((option) => option?.value === detail?.value);
                                                        if (existingOption) {
                                                            return { ...existingOption, isNew: false };
                                                        }
                                                        return { label: detail?.name || '', value: detail?.value || '', isNew: true };
                                                    })}
                                                    menuPlacement="auto"
                                                    menuPosition="fixed"
                                                    placeholder="Select or type..."
                                                />
                                            )
                                        }
                                    </div> 
                        </div>
                        <div className="row align-items-top mt10" style={{ padding: '3px 0' }}>
                            <div className="col-12 flex justify-content-center" >
                                <button
                                    type="button"
                                    className="btn btn-primary btn-outlined-main-primary  white-var"
                                    disabled={!isDataLoaded || isFormProcessing}
                                    onClick={() => {
                                        if (!isFormProcessing) {
                                            handleProcessSubmit()
                                        }
                                    }}
                                    style={{ lineHeight: '25px' }}
                                >
                                    {
                                        isFormProcessing ? (
                                            <>
                                                <FaSpinner className="fa-spin" /> Saving...
                                            </>
                                        ) : (
                                            <>
                                                <FaSave /> Save
                                            </>
                                        )
                                    }
                                    
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );

    return (
        <div
            className="d-flex"
            style={{
                width: '100vw',
                height: '100dvh',
                position: 'fixed',
                left: 0,
                top: 0,
                zIndex: 20,
                background: 'rgba(0,0,0,0.07)',
                justifyContent: 'center',
                alignItems: 'end',
                paddingBottom: '90px',
                backdropFilter: 'blur(8px)',
                WebkitBackdropFilter: 'blur(8px)'
            }}
        >
            <div
                className="popup color-popup-mobile d-md-none"
                style={{
                    position: 'relative',
                    transform: 'none',
                    top: 0,
                    left: 0,
                    maxWidth: '90%',
                    background: '#fff',
                    borderRadius: 12,
                    boxShadow: 'rgb(0 0 0 / 37%) 0px 0px 20px',
                    width: '100%',
                    padding: '24px 16px 0 16px',
                    display: 'flex',
                    flexDirection: 'column'
                }}
            >
                {/* Header */}
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        <ColoredColorIcon height={'36px'} width={'36px'} />
                        <span style={{ fontWeight: 600, fontSize: 18 }}>Model Details</span>
                    </div>
                </div>
                <div style={{ color: '#888', fontSize: 14, marginBottom: 18 }}>This model will be shown to the selection of models</div>
                <div className="form-group" style={{ marginBottom: 18 }}>
                    <label>Category</label>
                    
                    {
                        isDataLoaded == false ? (
                                <div style={{ width: '100%' }}>
                                    <Skeleton variant="rounded" width={'100%'} height={35} style={{ borderRadius: '12px' }} />
                                </div>
                        ) : (
                            <Select
                                className="rs-container-est-white"
                                classNamePrefix="rs"
                                isSearchable={true}
                                name="customer"
                                options={productCategories}
                                value={productCategories?.find((option) => option.value === information?.productCategoryId) || null}
                                onChange={(e) => {
                                setInformation({
                                    ...information,
                                    productCategoryId: e?.value
                                    });
                                }}
                            />
                        )
                    }
                </div>
                <div className="form-group" style={{ marginBottom: 18 }}>
                    
                    <label>Model Name</label>
                    {
                        isDataLoaded == false ? (
                            <div style={{ width: '100%' }}>
                                <Skeleton variant="rounded" width={'100%'} height={35} style={{ borderRadius: '12px' }} />
                            </div>
                        ) : (
                            <input
                                type="text"
                                className="form-control"
                                id="inputName"
                                value={information?.name}
                                placeholder='Color name'
                                onChange={(e) => {
                                    setInformation({
                                        ...information,
                                        name: e.target.value
                                    })
                                }}
                                onKeyDown={(e) => {
                                    handleProcessEnter(e);
                                }}
                            />
                        )
                    }
                </div>
                <div className="form-group" style={{ marginBottom: 18 }}>
                
                    <label>Colors</label>
                    {
                        isDataLoaded == false ? (
                            <div style={{ width: '100%' }}>
                                <Skeleton variant="rounded" width={'100%'} height={35} style={{ borderRadius: '12px' }} />
                            </div>
                        ) : (
                            <ReactSelectCreatable
                                className="rs-container"
                                classNamePrefix="rs"
                                options={productColors}
                                onChange={(e) => {
                                    setInformation({
                                        ...information,
                                        colors: e
                                    });
                                }}
                                isMulti={true}
                                value={information?.colors?.map((detail) => {
                                    // If detail is an object with label and value, use it directly
                                    if (detail?.label && detail?.value) {
                                        // Check if value exists in productColors
                                        const isExisting = productColors?.some((option) => option.value === detail.value);
                                        return { ...detail, isNew: !isExisting };
                                    }
                                    // If detail is an object with name and value, map to label/value
                                    if (detail?.name && detail?.value) {
                                        const isExisting = productColors?.some((option) => option.value === detail.value);
                                        return { label: detail.name, value: detail.value, isNew: !isExisting };
                                    }
                                    // If detail is a string (custom entry), map to label/value and mark as new
                                    if (typeof detail === 'string') {
                                        const isExisting = productColors?.some((option) => option.value === detail);
                                        return { label: detail, value: detail, isNew: !isExisting };
                                    }
                                    // Fallback: try to find in options
                                    const existingOption = productColors?.find((option) => option?.value === detail?.value);
                                    if (existingOption) {
                                        return { ...existingOption, isNew: false };
                                    }
                                    return { label: detail?.name || '', value: detail?.value || '', isNew: true };
                                })}
                                menuPlacement="auto"
                                menuPosition="fixed"
                                placeholder="Select or type..."
                            />
                        )
                    }
                </div>
                <div className="form-group" style={{ marginBottom: 18 }}>
                    
                    <label>Storage</label>
                    {
                        isDataLoaded == false ? (
                            <div style={{ width: '100%' }}>
                                <Skeleton variant="rounded" width={'100%'} height={35} style={{ borderRadius: '12px' }} />
                            </div>
                        ) : (
                            <ReactSelectCreatable
                                className="rs-container"
                                classNamePrefix="rs"
                                options={productStorages}
                                onChange={(e) => {
                                            setInformation({
                                                ...information,
                                                storages: e
                                            });
                                        }}
                                isMulti={true}
                                value={information?.storages?.map((detail) => {
                                    // If detail is an object with label and value, use it directly
                                    if (detail?.label && detail?.value) {
                                        // Check if value exists in productStorages
                                        const isExisting = productStorages?.some((option) => option.value === detail.value);
                                        return { ...detail, isNew: !isExisting };
                                    }
                                    // If detail is an object with name and value, map to label/value
                                    if (detail?.name && detail?.value) {
                                        const isExisting = productStorages?.some((option) => option.value === detail.value);
                                        return { label: detail.name, value: detail.value, isNew: !isExisting };
                                    }
                                    // If detail is a string (custom entry), map to label/value and mark as new
                                    if (typeof detail === 'string') {
                                        const isExisting = productStorages?.some((option) => option.value === detail);
                                        return { label: detail, value: detail, isNew: !isExisting };
                                    }
                                    // Fallback: try to find in options
                                    const existingOption = productStorages?.find((option) => option?.value === detail?.value);
                                    if (existingOption) {
                                        return { ...existingOption, isNew: false };
                                    }
                                    return { label: detail?.name || '', value: detail?.value || '', isNew: true };
                                })}
                                menuPlacement="auto"
                                menuPosition="fixed"
                                placeholder="Select or type..."
                            />
                        )
                    }
                </div>
                <div
                    className="btnarea"
                    style={{
                        position: 'sticky',
                        bottom: 0,
                        left: 0,
                        width: '100%',
                        background: '#fff',
                        padding: '16px 0 12px 0',
                        // zIndex: 30,
                        display: 'flex',
                        gap: 10,
                        justifyContent: 'center',
                        marginTop: 'auto'
                    }}
                >
                    <button
                        className="btn btn-main"
                        disabled={!isDataLoaded || isFormProcessing}
                        onClick={() => {
                            if (!isFormProcessing) handleProcessSubmit();
                        }}
                    >
                        {isFormProcessing ? (
                            <>
                                <FaSpinner className="fa-spin" /> Saving...
                            </>
                        ) : (
                            <>
                                <FaSave /> Save
                            </>
                        )}
                    </button>
                    <button className="btn new-btn-error" onClick={handleClose}>
                        <FaTimes /> Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ModelModal;
